import {
  getPaymentStatusLabel,
  getPaymentStatusVariant
} from "../utils/payment.utils";

const PaymentStatusBadge = ({
  status
}) => {
  const label =
    getPaymentStatusLabel(
      status
    );

  const variant =
    getPaymentStatusVariant(
      status
    );

  return (
    <span
      className={`payment-status-badge payment-status-badge--${variant}`}
    >
      {label}
    </span>
  );
};

export default PaymentStatusBadge;
